<template>
  <MainTabEvents :main-title="mainTitle">
    <div v-if="orders.length" class="main-tab__filters main-tab__filters--events">
      <div class="dea-input-container dea-input-container--events">
        <label class="dea-input-container__label dea-input-container__label--date" for="startDate">
          Seleziona una data
        </label>
        <div class="dea-input-container__inputs">
          <datepicker
            id="startDate"
            input-class="dea-input dea-input--date"
            placeholder="Seleziona Data Inizio"
            :disabled-dates="disabledFromDates"
            :language="it"
            :value="selectedFromDateFilter"
            @selected="handleSelectedFromDateFilter"
          ></datepicker>
          <datepicker
            input-class="dea-input dea-input--date"
            placeholder="Seleziona Data Fine"
            :disabled-dates="disabledToDates"
            :language="it"
            :value="selectedToDateFilter"
            @selected="handleSelectedToDateFilter"
          ></datepicker>
        </div>
      </div>
    </div>
    <ContentWrapper :class="contentWrapperExtraClasses">
      <template #default>
        <Loader v-if="!ordersLoaded"></Loader>
        <template v-else-if="orders.length">
          <OrderCard v-for="order in orders" :key="order.id" :order="order"></OrderCard>
        </template>
        <template v-else>
          <div class="dea-heading--medium__ml">
            Nessun corso acquistato
          </div>
        </template>
      </template>
    </ContentWrapper>
    <PaginationBlock
      v-if="myOrdersPagination.pages.length > 1"
      :pagination="myOrdersPagination"
      @changePage="changePage"
    ></PaginationBlock>
  </MainTabEvents>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
import Loader from "@/components/elements/Loader";
import PaginationBlock from "@/components/elements/PaginationBlock";
import OrderCard from "@/components/patterns/OrderCard"; // eslint-disable-line import/no-extraneous-dependencies
import MainTabEvents from "~/components/events/components/MainTabEvents";
import ContentWrapper from "~/components/events/components/ContentWrapper";

export default {
  name: "EventsOrders",
  components: {
    ContentWrapper,
    Loader,
    MainTabEvents,
    OrderCard,
    PaginationBlock,
    Datepicker,
  },
  data() {
    return {
      disabledFromDates: { to: new Date(2019, 0, 1) },
      disabledToDates: { to: new Date(2019, 0, 1) },
      ticketWrapperComponent: "",
      versionIndex: 0,
      preRegistrationFilter: null,
      inputSelectFilters: [
        { id: "default", name: "Tutti", value: "" },
        { id: "active", name: "Attivo", value: "active" },
        { id: "past", name: "Partecipato", value: "past" },
        { id: "notAttended", name: "Non partecipato", value: "notAttended" },
      ],
      selectedFilter: "",
      selectedFromDateFilter: undefined,
      selectedToDateFilter: undefined,
      it,
    };
  },
  computed: {
    ...mapGetters(["ticketFilter", "titles", "orders", "ordersLoaded", "myOrdersPagination"]),
    mainTitle() {
      return this.titles.main[this.ticketFilter];
    },
    contentWrapperExtraClasses() {
      if (this.ticketFilter === "ordersRecap") {
        return "content-wrapper--reduced-margin";
      }
      return "";
    },
  },
  created() {
    this.fetchOrders();
  },
  methods: {
    ...mapActions(["fetchOrders"]),
    ...mapMutations(["setViewChanged", "setPage", "setFromDateFilter", "setToDateFilter"]),

    async changePage(page) {
      let newPage = page;
      if (page === "prev" && this.myOrdersPagination.has_previous) {
        newPage = this.myOrdersPagination.current - 1;
      } else if (page === "next" && this.myOrdersPagination.has_next) {
        newPage = this.myOrdersPagination.current + 1;
      } else if (page === "first" && this.myOrdersPagination.has_previous) {
        newPage = 1;
      } else if (page === "last" && this.myOrdersPagination.has_next) {
        newPage = this.myOrdersPagination.last;
      }

      if (newPage === this.myOrdersPagination.current) return;

      this.setViewChanged(true);
      this.setPage(newPage);
      await this.fetchOrders();
    },

    async handleSelectedFromDateFilter(event) {
      if (event?.getTime() === this.selectedFromDateFilter?.getTime()) {
        return;
      }
      this.setViewChanged(true);
      this.setPage(1);
      this.setFromDateFilter(event);
      await this.fetchOrders();
      this.selectedFromDateFilter = event;
    },

    async handleSelectedToDateFilter(event) {
      if (event?.getTime() === this.selectedToDateFilter?.getTime()) {
        return;
      }
      this.setViewChanged(true);
      this.setPage(1);
      this.setToDateFilter(event);
      await this.fetchOrders();
      this.selectedToDateFilter = event;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.subscription-container {
  &__paragraph {
    margin-bottom: $space-base;
    margin-top: $space-x-large;
  }
}
</style>
